import { render, staticRenderFns } from "./OneConsult.vue?vue&type=template&id=0facd78f&scoped=true"
import script from "./OneConsult.vue?vue&type=script&lang=js"
export * from "./OneConsult.vue?vue&type=script&lang=js"
import style0 from "./OneConsult.vue?vue&type=style&index=0&id=0facd78f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0facd78f",
  null
  
)

export default component.exports